export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
export const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_API_URL || 'https://uploads.traffixcloud.com';
export const UPLOADS_PROJECT_NAME = 'traffix_all_in_one';
export const REQUIRE_AUTH = process.env.REACT_APP_REQUIRE_AUTH !== 'false';

export function backendUrl(path = '') {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${clean}`;
}
